function initializeTracking(videoId, player) {
  // Plugin for tracking
  const Plugin = videojs.getPlugin('plugin');
  class Tracking extends Plugin {
    constructor(player, options) {
      super(player, options);

      this.percentsTracked = [];

      player.on('playing', function () {
        ahoy.start();
        ahoy.track('video_play', {
          user_type: currentUser.type,
          user_id: currentUser.id,
          video_id: videoId,
          article_id: currentPage.articleId,
          page: window.location.pathname,
        });
      });

      player.on('pause', function () {
        if (player.currentTime() === player.duration()) return;
        ahoy.start();
        ahoy.track('video_pause', {
          user_type: currentUser.type,
          user_id: currentUser.id,
          video_id: videoId,
          article_id: currentPage.articleId,
          page: window.location.pathname,
        });
      });

      player.on('ended', function () {
        ahoy.start();
        ahoy.track('video_finished', {
          user_type: currentUser.type,
          user_id: currentUser.id,
          video_id: videoId,
          article_id: currentPage.articleId,
          page: window.location.pathname,
        });
      });

      player.on('timeupdate', () => {
        let currentTime, duration, percent, percentPlayed;
        currentTime = Math.round(player.currentTime());
        duration = Math.round(player.duration());
        percentPlayed = Math.round((currentTime / duration) * 100);

        // Track percents in increments of 25
        for (percent = 0; percent <= 99; percent += 25) {
          if (percent > 0 && percentPlayed > percent && !this.percentsTracked.includes(percent)) {
            this.percentsTracked.push(percent);
            const ahoy_event = 'video_' + percent + '_watched';
            ahoy.track(ahoy_event, {
              user_type: currentUser.type,
              user_id: currentUser.id,
              video_id: videoId,
              article_id: currentPage.articleId,
              page: window.location.pathname,
            });
          }
        }

        // Track 90 percent mark
        if (percentPlayed >= 90 && this.percentsTracked.indexOf(90) === -1) {
          this.percentsTracked.push(90);
          ahoy.track('video_90_watched', {
            user_type: currentUser.type,
            user_id: currentUser.id,
            video_id: videoId,
            article_id: currentPage.articleId,
            page: window.location.pathname,
          });
        }
      });
    }
  }

  // Register and call plugin
  videojs.registerPlugin('tracking', Tracking);
  player.tracking({ videoId: videoId });
}

export default initializeTracking;
